import type { KpiComputeRequestPayload } from '../servicebus/kpi';
import { KPI_COMPUTE_TRIGGER } from '../servicebus/kpi';
import { KPI_GRANULARITY, KPI_KEYS } from '../kpi/kpi.interface';
import { ObjectFactory } from './object.factory';

export class KpiComputeRequestPayloadFactory extends ObjectFactory<KpiComputeRequestPayload> {
  protected getDefaults(): KpiComputeRequestPayload {
    return {
      from: { day: 1, month: 9, year: 2026 },
      granularity: KPI_GRANULARITY.MONTH,
      key: KPI_KEYS.ORDER_KPIS,
      to: { day: 30, month: 9, year: 2026 },
      trigger: KPI_COMPUTE_TRIGGER.API,
      userId: 'aabbccddeeff001122334455',
    };
  }
}

// Pre-instantiated for convenience
export const kpiComputeRequestPayloadFactory = new KpiComputeRequestPayloadFactory();
